import { StyleSheet } from 'react-native';
import {
  darkestGrey,
  fontFamilyLight,
  fontFamilySemiBold,
  fontSizeSmall,
} from '../../constants/palette';

const styles = StyleSheet.create({
  buttonContainer: {
    marginTop: 20,
  },
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    width: '90%',
    margin: 20,
  },
  title: {
    fontFamily: fontFamilySemiBold,
    textAlign: 'center',
  },
  subHeader: {
    fontFamily: fontFamilyLight,
    fontSize: fontSizeSmall,
    marginBottom: 10,
  },
  separator: {
    marginVertical: 30,
    height: 1,
    width: '80%',
  },
  activeButtonStyle: {
    alignItems: 'center',
    minWidth: 20,
    margin: 3,
    marginVertical: 3,
  },
  inactiveButtonStyle: {
    alignItems: 'center',
    minWidth: 20,
    margin: 3,
    marginVertical: 3,
    backgroundColor: darkestGrey,
  },
});

export default styles;
